// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"244":"naija","251":"recipes","443":"about","578":"singles","904":"accom","907":"places"}[chunkId] + "." + {"244":"e9f2fbc2","251":"22b2604d","443":"0061d9ad","578":"1fad85a4","904":"2f139335","907":"b221dcbf"}[chunkId] + ".css";
};